import download from "@/views/download/download";
export default download;
